import { AlertClassColour, ConfigSystemParams, msSize } from 'src/app/core/consts';
import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, Observable, throwError } from 'rxjs';
import { CompletedModalFormComponent } from '../../_pop-ups/completed-modal-form/completed-modal-form.component';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { OurDate } from 'src/app/core/interfaces/general/our-date';
import { populateOurDate } from 'src/app/core/functions-generic/functions-generic-date';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { TariffsUsageSchemeRateService } from 'src/app/core/services/utelize/system/tariff/tariffs-usage-scheme-rate-service';
import { TariffsUsageSchemeService } from 'src/app/core/services/utelize/system/tariff/tariffs-usage-scheme-service';
import { TariffsUsageService } from 'src/app/core/services/utelize/system/tariff/tariffs-usage-service';
import { TariffUsageSchemeRateDTO } from 'src/app/core/models/system/tariff/tariff-usage-scheme-rate.dto';
import { WarningModalFormComponent } from '../../_pop-ups/warning-modal-form/warning-modal-form.component';

@Component({
  selector: 'app-tariffs-usage-scheme-rate-modal-form',
  templateUrl: './tariffs-usage-scheme-rate-modal-form.component.html',
  styleUrls: ['./tariffs-usage-scheme-rate-modal-form.component.scss']
})

export class TariffsUsageSchemeRateModalFormComponent implements AfterViewInit, OnDestroy, OnInit {

  @Output() thisFormCancelled: EventEmitter<void>  =new EventEmitter<void>();
  @Output() thisFormSaved    : EventEmitter<number>=new EventEmitter<number>();
  
  @ViewChild('completedModalForm', { static: false }) completedModalForm!: CompletedModalFormComponent;
  @ViewChild('thisModalForm',      { static: false }) thisModalForm!     : TemplateRef<void>;
  @ViewChild('warningModalForm',   { static: false }) warningModalForm!  : WarningModalFormComponent;
  
  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false) }
                       
  private initialStatus           : string="Please complete the following details";
  private newUsageTariffSchemeRate: boolean=false;
  private schemeIdData!           : IdAndDescriptionDTO[];
  private thisModalFormRef!       : NgbModalRef;
  private usageTariffIdData!      : IdAndDescriptionDTO[];
  private usageTariffSchemeRate   : TariffUsageSchemeRateDTO | undefined;
  private usageTariffSchemeRateId : number | undefined;
  
  public alertColourProgress    : string=AlertClassColour.Grey;
  public curUser                : SystemUserDTO;
  public endDate                : OurDate | undefined;
  public formTitle              : string="Usage Tariff Scheme Rate";
  public progressInformation    : string=this.initialStatus;
  public progressInformationShow: boolean=false;
  public startDate              : OurDate | undefined=populateOurDate(this.exceptionsService, Date.now());
  public thisForm!              : UntypedFormGroup;
  public thisFormSubmitted      : boolean=false;
  
  constructor(
    private authenticationService        : AuthenticationService,
    private configSystemService          : ConfigSystemService,
    private exceptionsService            : ExceptionsService,
    private formBuilder                  : UntypedFormBuilder,
    private lastPassKillerService        : LastPassKillerService,
    private modalService                 : NgbModal,
    private tariffsUsageSchemeRateService: TariffsUsageSchemeRateService,
    private tariffsUsageSchemeService    : TariffsUsageSchemeService,
    private tariffsUsageService          : TariffsUsageService
  ) {
    this.curUser=this.authenticationService.currentUserObject();
  }

  public ngOnInit(): void {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngOnDestroy(): void {
    try {
      this.lastPassKillerService.stop();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public resetMainVariables(): void {
    try {
      this.alertColourProgress     =AlertClassColour.Grey;
      this.endDate                 =undefined;
      this.newUsageTariffSchemeRate=false;
      this.progressInformation     =this.initialStatus;
      this.startDate               =populateOurDate(this.exceptionsService, Date.now());
      this.thisFormSubmitted       =false;
      this.usageTariffSchemeRate   =undefined;
      this.usageTariffSchemeRateId =undefined;

      this.refreshUsageTariffData();
      this.refreshUsageTariffSchemeData();
      this.resetProgressInformation();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public resetProgressInformation() {
    try {
      this.alertColourProgress    =AlertClassColour.Grey;
      this.progressInformation    =this.initialStatus;
      this.progressInformationShow=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openForm(usageTariffSchemeRateId: number | undefined): void {
    try {
      this.resetMainVariables();
      this.setUpForm();
      this.enableDisableControls(false);

      if (usageTariffSchemeRateId != undefined && <number>usageTariffSchemeRateId>0) {
        this.usageTariffSchemeRateId=usageTariffSchemeRateId;

        this.getUsageTariffSchemeRateAndOpenModal();

      } else {
        this.newUsageTariffSchemeRate=true;

        this.openModal();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
      
  public getUsageTariffSchemeRateAndOpenModal() {
    try {
      this.tariffsUsageSchemeRateService.getById(<number>this.usageTariffSchemeRateId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.usageTariffSchemeRate=data;
           
          this.populateFormFields(this.thisForm);
          this.openModal();
         },
        error: error => {
          this.thisFormCancelled.emit();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openModal(): void {
    try {
      this.thisModalFormRef=this.modalService.open(this.thisModalForm, { backdrop: this.modalBackGround, 
                                                                         centered: true,
                                                                         keyboard: false,
                                                                         size    : msSize.Large });
    }
    catch(e) {
      this.thisFormCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region thisForm

  get formOfThis() {
    return this.thisForm.controls;
  }

  private setUpForm() {
    try {
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildForm() {
    try {
      this.removeFormFields(this.thisForm);

      this.thisForm=this.formBuilder.group({ });
      
      this.addFormFields(this.thisForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.thisForm) {
        this.addFormControl(formGroup, "active",        true,      []);
        this.addFormControl(formGroup, "endDate",       undefined, []);
        this.addFormControl(formGroup, "schemeId",      undefined, [Validators.required]);
        this.addFormControl(formGroup, "startDate",     undefined, [Validators.required]);
        this.addFormControl(formGroup, "usageTariffId", undefined, [Validators.required]);

        this.thisForm.controls["startDate"].setValue(this.startDate?.date);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : boolean | number | string | undefined,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(
        value,
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private populateFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.thisForm && this.usageTariffSchemeRate) {
        this.thisForm.controls["active"].setValue(this.usageTariffSchemeRate.active);
        this.thisForm.controls["endDate"].setValue(this.usageTariffSchemeRate.endDate);
        this.thisForm.controls["schemeId"].setValue(this.usageTariffSchemeRate.schemeID);
        this.thisForm.controls["startDate"].setValue(this.usageTariffSchemeRate.startDate);
        this.thisForm.controls["usageTariffId"].setValue(this.usageTariffSchemeRate.usageTariffID);

        this.startDate=populateOurDate(this.exceptionsService, this.usageTariffSchemeRate.startDate);

        if (this.usageTariffSchemeRate.endDate)
          this.endDate=populateOurDate(this.exceptionsService, this.usageTariffSchemeRate.endDate);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private enableDisableControls(enabled: boolean) {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public thisFormSubmitAttempt() {
    try {
      this.thisFormSubmitted=true;

      if (this.thisForm.valid) {
          this.thisFormSubmit();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public thisFormSubmit() {
    try {
      this.prepareToSaveUsageTariffSchemeRate();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public thisFormCancel() {
    try {
      this.thisFormCancelled.emit();
      this.thisModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Dropdown Arrays

  public getDropdownDataObjectArray(fieldName: string) {
    try {
      if (fieldName=="schemeId") {
        return this.schemeIdData;
        
      } else if (fieldName=="usageTariffId") {
        return this.usageTariffIdData;
        
      }
      
      return undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return undefined;
    }
  }

  private getDropdownData(dataSource: Observable<any>, fieldName: string) {
    try {
      if (dataSource) {
        dataSource
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            if (fieldName=="schemeId") {
              this.schemeIdData=(data as IdAndDescriptionDTO[]);
              
            } else if (fieldName=="usageTariffId") {
              this.usageTariffIdData=(data as IdAndDescriptionDTO[]);
              
            }
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Refresh Dropdown Arrays Data

  public refreshUsageTariffData() {
    try {
      this.getDropdownData(this.tariffsUsageService.getIdAndDescription(), "usageTariffId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshUsageTariffSchemeData() {
    try {
      this.getDropdownData(this.tariffsUsageSchemeService.getIdAndDescription(), "schemeId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#endregion

  public startDateChanged(startDate: OurDate) {
    try {
      this.startDate=startDate;

      this.thisForm.controls["startDate"].setValue(this.startDate.date);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public endDateChanged(endDate: OurDate) {
    try {
      this.endDate=endDate;

      this.thisForm.controls["endDate"].setValue(this.endDate.date);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private prepareToSaveUsageTariffSchemeRate() {
    try
    {
      this.resetProgressInformation();
        
      let usageTariffSchemeRate: TariffUsageSchemeRateDTO={
        active       : this.thisForm.controls["active"].value,
        endDate      : this.thisForm.controls["endDate"].value,
        enteredBy    : this.curUser.userId,
        id           : this.usageTariffSchemeRateId ?? -1,
        schemeID     : this.thisForm.controls["schemeId"].value,
        startDate    : this.thisForm.controls["startDate"].value,
        usageTariffID: this.thisForm.controls["usageTariffId"].value
      };
                  
      this.saveUsageTariffSchemeRate(usageTariffSchemeRate)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.processComplete();
                  
          if (this.newUsageTariffSchemeRate) {
            this.usageTariffSchemeRateId=data["id"];
          }
          
          this.thisFormSaved.emit(this.usageTariffSchemeRateId);
        },
        error: error => {
          this.alertColourProgress    =AlertClassColour.Red;
          this.progressInformation    =`Process cannot continue - ${error.message}`;
          this.progressInformationShow=true;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
                  
  private saveUsageTariffSchemeRate(usageTariffSchemeRate: TariffUsageSchemeRateDTO): Observable<TariffUsageSchemeRateDTO> {
    return this.tariffsUsageSchemeRateService.save(usageTariffSchemeRate);
  }

  //#region Process Complete

  private processComplete() {
    try {
      this.completedModalForm.openForm(this.newUsageTariffSchemeRate ? "Usage Tariff Scheme Rate Created" : "Usage Tariff Scheme Rate Details Updated", "");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public completedModalFormClosed() {
    try {
      this.thisModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
}
